export default __webpack_public_path__ + "static/media/background.b3c1beb7.svg";